import React, { FC } from 'react';
import { Button, Typography } from 'antd';
import { formatCurrency } from 'common/helpers/format.helper';
import { ReactComponent as PlusIcon } from 'app/assets/images/plus.svg';
import { IOrderItemModel } from 'entities/Orders/Orders.models';
import { MenuItemImage } from 'entities/Menu/components/MenuItemImage';

interface IComponentProps {
  item: IOrderItemModel;
  onClick: (item: IOrderItemModel) => void;
}

export const LastOrderItemCard: FC<IComponentProps> = ({ item, onClick }) => {
  const { assetItemData } = item;
  const { image, isEnable, name, price } = assetItemData;
  const isAvailableItem = isEnable ?? false;
  // Reorder shows the current per-unit menu price, not the order's stored total
  // (which is multiplied by the ordered quantity and is 0 for reward items).
  const totalText = isAvailableItem ? formatCurrency(price) : 'Out of stock';

  const onCardClick = (e: React.MouseEvent) => {
    e.stopPropagation();

    if (!isAvailableItem) {
      return;
    }

    onClick(item);
  };

  return (
    <div className={`last-order-item-card ${!isAvailableItem ? 'last-order-item-card-unavailable' : ''}`} onClick={onCardClick}>
      <div>
        <div>
          {image ? (
            <div className="last-order-item-card-image-wrapper">
              <MenuItemImage src={image} className="last-order-item-card-image" alt={name || 'last order item'} />
              <div className="last-order-item-card-add-btn-wrapper">
                <Button className="last-order-item-card-add-btn" icon={<PlusIcon />} />
              </div>
            </div>
          ) : null}
        </div>
        <Typography.Paragraph ellipsis={{ rows: 3 }} className="mb-0 fs-xxxs">
          {name}
        </Typography.Paragraph>
      </div>
      <Typography.Paragraph className={`mb-0 font-weight-bold ${!isAvailableItem ? 'color-gray' : ''}`}>
        {totalText}
      </Typography.Paragraph>
    </div>
  );
};
